import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {
  DataObjectId,
  stickerDeadlineAsStatisticsDatesProperty,
  StickerIcon,
  stickerIconProperty,
  stickerReadonlyProperty,
  StickerType,
  stickerTypeProperty,
  Tag
} from 'yougile-model'
import {Project} from '../../../extensions/project'

const onProjectStickerCommit = () => logger.log('Project sticker commited!')

export const getProjectSticker = (companyId: DataObjectId) => {
  const t = new Tag(companyId, Lang.msg.statFilterProject)
  t.id = 'project' as DataObjectId
  t.states = {index: {}, order: []}
  const projects = Project.listProjects(companyId, 'not-archive').sort(
    Project.projectOrderComparer
  )
  projects.forEach(p => {
    t.states.index[p.id] = {id: p.id, name: p.title}
    t.states.order.push(p.id)
  })
  const type: StickerType = 'string'
  t.properties[stickerTypeProperty] = type
  const icon: StickerIcon = 'box'
  t.properties[stickerIconProperty] = icon
  t.properties[stickerReadonlyProperty] = true
  t.onCommit = onProjectStickerCommit
  return t
}

const onAssignDateCommit = () => logger.log('date commited!')

export const getAssignDateSticker = (companyId: DataObjectId) => {
  const t = new Tag(companyId, Lang.msg.byUserFilterAssignDate)
  t.id = 'assignDate' as DataObjectId
  t.states = {
    index: {},
    order: []
  }
  const type: StickerType = 'deadline'
  t.properties[stickerTypeProperty] = type
  t.properties[stickerDeadlineAsStatisticsDatesProperty] = true
  t.onCommit = onAssignDateCommit
  return t
}

const onUserStickerCommit = () => logger.log('user commited!')

export const getUserSticker = (companyId: DataObjectId) => {
  const t = new Tag(companyId, Lang.msg.statFilterUser)
  t.id = 'user' as DataObjectId
  const type: StickerType = 'user'
  t.properties[stickerTypeProperty] = type
  t.properties[stickerReadonlyProperty] = true
  t.onCommit = onUserStickerCommit
  return t
}
